import React, { useState } from "react";
import "./Footer.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  Slider,
  Checkbox,
  Dropdown_aspect,
  ColorPicker,
  NumberInput,
} from "../../../Components/";
import { useSelector, useDispatch } from "react-redux";
import {
  updateSettingOptionState,
  saveProjectSettings,
  updateProjectCreditsByGoogle,
  updateProjectCredits,
} from "../../../Redux/actions/projectActions";
import CloneProjectModal from "../CloneProject/CloneProjectModal";
import Render from "../Render/Render";
import RenderNew from "../Render/RenderNew";
import {
  selectedPageOption,
  setGlobalColorInReudx,
} from "../../../Redux/actions/commonActtion";
import CardRender from "../Cards/CardRender";
import { AiOutlineGlobal } from "react-icons/ai";
import CustomToast, {
  customToatStyle,
  customToatStyleError,
} from "../../../Components/CustomToast/CustomToast";
import { read, utils } from "xlsx";
import { excelDataToCredits } from "../../../services/excelDataToProjectData";
import { CreditBtnIcon, SyncNav } from "../../../assets/icons";
import { useLocation, useNavigate } from "react-router-dom";
const debounceTimeoutIds = {};

const getUpdatedProjectCredits = (currentCredits, newCredits) => {
  try {
    const updatedCredits = newCredits;
    for (let i = 0; i < newCredits.length; i++) {
      let idx = currentCredits.findIndex(
        (credit) =>
          credit.options.block_name == newCredits[i].options.block_name,
      );
      if (
        idx !== -1 &&
        currentCredits[idx].options.block_type ==
          newCredits[i].options.block_type
      ) {
        updatedCredits[i].options = currentCredits[idx].options;
      }
    }
    return { data: updatedCredits };
  } catch (error) {
    return { error, data: null };
  }
};

const Footer = ({
  currentBlockOptions,
  isTitleSafe,
  setIsTitleSafe,
  getBlockSize,
  aspectRatio_FrameSize,
  setAspectRatio_FrameSize,
  handleFooterClick,
  isCard,
  setIsDisplayTitle,
  isDisplayTitle,
  isRenderExport,
  setIsRenderExport,
  setReLoading,
}) => {
  // console.log('currentBlockOptions  = ',currentBlockOptions?.text_alignment==='gutter' || currentBlockOptions?.text_alignment==='ragged'
  // )
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  let { isDashboard } = location?.state;
  // console.log('Footer location = ',isDashboard ,location);

  const [selectedID, setSelectedID] = useState("");
  const {
    googleSheetLink,
    _id,
    googleSpreadSheetId,
    credits: currentCredits,
    currentBlock,
  } = useSelector((state) => state?.project);
  const projectSettings = useSelector((state) => state.project.settings);

  const [renderOpen, setRenderOpen] = useState(false);
  const [projectCloneModalOpen, setProjectCloneModalOpen] = useState(false);
  const [options, setOptions] = useState([
    { label: "None", value: "hdnone" },
    { label: "16:9", value: "Class1x78" },
    { label: "4:3", value: "Class1x33" },
    { label: "1.85:1", value: "Class1x85" },
    { label: "2.39:1", value: "Class2x39" },
  ]);

  const { gobalBGcolor } = useSelector((state) => state?.commonReducer);
  const updateProjectSettingsState = (key, value) =>
    dispatch(updateSettingOptionState(key, value));
  const saveProjectSettingsCall = () => dispatch(saveProjectSettings());
  // const debouncedSettingsSave = debounce(saveProjectSettingsCall, 1000);
  const debouncedSave = (key, value) => {
    if (debounceTimeoutIds[key]) {
      clearTimeout(debounceTimeoutIds[key]);
      debounceTimeoutIds[key] = null;
    }
    debounceTimeoutIds[key] = setTimeout(() => {
      saveProjectSettingsCall(key, value);
    }, 1500);
  };

  const handleGoogleUpdate = async () => {
    await setReLoading({ condn: true, label: "Syncing..." });

    try {
      const res = await dispatch(
        updateProjectCreditsByGoogle(
          _id,
          googleSpreadSheetId,
          currentCredits,
          isCard,
        ),
      );
      if (res?.success === true) {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast title="" content={res?.message} />,
            customToatStyle,
          );
        }, 300);
      } else {
        await setReLoading({ condn: false, label: "" });
        setTimeout(() => {
          toast(
            <CustomToast
              isError
              title={res?.response?.data?.title || "Error"}
              content={res?.response?.data?.message}
            />,
            customToatStyleError,
          );
        }, 2000);
      }
    } catch (err) {
      await setReLoading({ condn: false, label: "" });
    }
  };

  const handleFileInput = (file) => {
    try {
      const reader = new FileReader();
      reader.onload = (evt) => {
        const binaryStr = evt.target.result;
        const wb = read(binaryStr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const jsonData = utils.sheet_to_json(ws, { header: 1 });
        const newCredits = excelDataToCredits(jsonData);
        const { data: updatedCredits, error } = getUpdatedProjectCredits(
          currentCredits,
          newCredits,
        );
        if (error) {
          return error;
        }
        dispatch(updateProjectCredits(_id, updatedCredits));
      };
      reader.readAsBinaryString(file);
    } catch (err) {
      return err;
    }
  };

  const OptionHandler = (val) => {
    dispatch(selectedPageOption(val, _id, isCard));
    navigate("", {
      state: {
        isDashboard: isDashboard,
        isRender: true,
        projectId: _id,
        isCard: isCard ? isCard : false,
      },
      replace: true,
    });
  };

  return (
    <>
      <div className="main-footer">
        <div className="centerBottom">
          {currentBlockOptions?.text_alignment === "ragged" ? (
            <div className="">
              <Slider
                RaggedGutter={projectSettings?.ragged_gutter}
                label={"Ragged Gutter"}
                value={projectSettings?.ragged_gutter}
                handleChange={(val) => {
                  updateProjectSettingsState("ragged_gutter", val);
                  debouncedSave();
                }}
                min={0}
                max={15}
                step={1}
              />
            </div>
          ) : currentBlockOptions?.text_alignment === "center" ||
            currentBlockOptions?.text_alignment === "gutter" ? (
            <div className="w-[25%]">
              <Slider
                gutter={projectSettings?.gutter}
                label={"Gutter"}
                value={projectSettings?.gutter}
                handleChange={(val) => {
                  updateProjectSettingsState("gutter", val);
                  debouncedSave();
                }}
                min={0}
                max={15}
                step={1}
              />
            </div>
          ) : null}

          {isCard ? (
            ""
          ) : (
            <div className="flex items-center justify-center ml-2 xl:ml-4 2xl:ml-2">
              <div
                className="w-full h-full flex align-center"
                style={{
                  marginRight:
                    currentBlockOptions?.text_alignment === "center" ||
                    currentBlockOptions?.text_alignment === "gutter"
                      ? ""
                      : "25px",
                }}
              >
                <Dropdown_aspect
                  options={options}
                  value={aspectRatio_FrameSize}
                  aspectRatio_FrameSize={aspectRatio_FrameSize}
                  setAspectRatio_FrameSize={setAspectRatio_FrameSize}
                  label={"Ratio"}
                  selectedID={selectedID}
                  onChange={(value) => {
                    getBlockSize("aspectRatio_frame", value);

                    const idx = options.findIndex((opt) => opt.value === value);
                    if (idx !== -1) {
                      setSelectedID(idx);
                    }
                  }}
                />
              </div>
            </div>
          )}

          {isCard ? (
            ""
          ) : (
            <div
              className=""
              style={{
                display:
                  currentBlockOptions?.text_alignment === "center" ||
                  currentBlockOptions?.text_alignment === "gutter"
                    ? ""
                    : "none",
              }}
            >
              {/* <span className="h-[20px] border-r-[1px] border-[#2a2740]" /> */}
            </div>
          )}
        </div>

        <div className="rightBottom">
          {!isCard && (
            <div
              className="titleSafeToggle"
              onClick={() => setIsTitleSafe(!isTitleSafe)}
            >
              <span className="titleSafeToggle_label">Title Safe</span>
              <button
                type="button"
                className={`titleSafeToggle_switch ${isTitleSafe ? "is-on" : ""}`}
                aria-pressed={isTitleSafe}
                aria-label="Toggle title-safe guide"
              >
                <span className="titleSafeToggle_knob" />
              </button>
            </div>
          )}

          {isCard && (
            <div
              className="titleSafeToggle"
              onClick={() => setIsDisplayTitle(!isDisplayTitle)}
            >
              <span className="titleSafeToggle_label">Title Safe</span>
              <button
                type="button"
                className={`titleSafeToggle_switch ${isDisplayTitle ? "is-on" : ""}`}
                aria-pressed={isDisplayTitle}
                aria-label="Toggle title display"
              >
                <span className="titleSafeToggle_knob" />
              </button>
            </div>
          )}
          <div className=" flex justify-center items-center "></div>
        </div>

        <CloneProjectModal
          projectCloneModalOpen={projectCloneModalOpen}
          setProjectCloneModalOpen={setProjectCloneModalOpen}
        />
      </div>
    </>
  );
};

export default Footer;
